export interface IDashRegistrationLog {
    
}